import React, { FC } from 'react';

// v2 vote caret — solid-stroked triangle (Component Library "Votes & Polls" spec)
const VoteCaret: FC<{ dir: 'up' | 'down'; color: string; size?: number }> = ({ dir, color, size = 18 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth={2.2}
    strokeLinejoin="round"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <path d={dir === 'up' ? 'M12 5l7 7H5z' : 'M12 19l-7-7h14z'} />
  </svg>
);

export default VoteCaret;
